const id_master_finance = {
    "": "keuangan",

    coa: "Pengaturan COA",
    number: "Pengaturan Nomor Keuangan",

    field_coa: {
        KAS: "kas",
        SALES: "penjualan",
        PPN_SALES: "PPN penjualan",
        HPP_SALES: "HPP penjualan",
        PURCHASE: "pembelian",
        PPN_PURCHASE: "PPN pembelian",
        CREDIT: "hutang",
        DEBIT: "piutang",
        DP: "down payment",
        SUPPLY: "persediaan barang",
        PRODUCTION: "proses produksi",
        RETUR_CUSTOMER: "retur pelanggan",
        STOCK_RETUR_CUSTOMER: "persediaan barang retur pelanggan",
        RETUR_DEBT: "bayar hutang retur",
        COMMISSION: "komisi",
        COMMISION_DEBT: "hutang komisi"
    },

    field_fn: {
        SALES: "penjualan",
        PURCHASE: "pembelian",
        SALES_CODE: "kode penjualan",
        PURCHASE_CODE: "kode pembelian",
    },

    error: {
        update_coa: "Gagal mengubah Pengaturan COA",
        update_number: "Gagal mengubah Pengaturan Nomor Keuangan",
    },

    success: {
        update_coa: "Berhasil mengubah Pengaturan COA",
        update_number: "Berhasil mengubah Pengaturan Nomor Keuangan",
    }
}

export default id_master_finance;